import { defineStyleConfig } from '@chakra-ui/react';

export const TooltipOverrides = defineStyleConfig({
  baseStyle: {
    fontSize: 'xSmall',
    p: '8px',
  },
  defaultProps: {},
});
